class CurrentLocation {
    currentLocationId = null;
    currentLocationName = null;
    upperLocationContainer = null;
    upperLocationLink = null;
    upperLocationSelect = null;
    upperLocationSelectContainer = null;

    locationToggle() {
        if (this.upperLocationContainer) {

            if (this.upperLocationLink) {

                this.upperLocationLink.addEventListener("click", (e) => {
                    if (!this.upperLocationLink.classList.contains("list-active")) {
                        this.upperLocationSelectContainer.classList.add("list-active");
                        this.upperLocationLink.classList.add("list-active");
                    } else {
                        this.upperLocationSelectContainer.classList.remove("list-active");
                        this.upperLocationLink.classList.remove("list-active");
                    }
                })
            }
        }
    }

    upperLocationChange() {
        if (this.upperLocationSelect) {
            this.upperLocationSelect.addEventListener("change", (e) => {
                if (e.target.value) {
                    const locationName = e.target.querySelector(`[value='${e.target.value}'`).id;
                    document.cookie = `locationId=${e.target.value}; path=/;`;
                    document.cookie = `locationName=${locationName}; path=/;`
                    window.location.reload();
                }
            })
        }
    }

    constructor(upperLocation) {
        this.currentLocationId = localStorage.getItem("locationId");
        this.currentLocationName = localStorage.getItem("locationName");
        this.upperLocationContainer = upperLocation;
        this.upperLocationLink = upperLocation.querySelector('.utility-nav-location-link');
        this.upperLocationSelect = upperLocation.querySelector(".utility-nav-location-select");
        this.upperLocationSelectContainer = upperLocation.querySelector(".utility-nav-location-select-container")
        this.locationToggle();
        this.upperLocationChange();
    }
}

export default CurrentLocation;